module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dropdown-menu', _vm._b({}, 'el-dropdown-menu', _vm.$attrs, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c3b1232"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/dropdown/rtDropdownMenu.vue
// module id = 2153
// module chunks = 137